import React from 'react';
import { Spin } from 'antd';

class FullPageSpinner extends React.Component {
  render() {
    const { spinning, tip = "Loading..." } = this.props;

    if (!spinning) return null;

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin size="large" tip={tip} />
      </div>
    );
  }
}

export default FullPageSpinner;



// WEBPACK FOOTER //
// ./src/components/Inc/FullPageSpinner.js